import { Outlet } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { LayoutProvider, MasterInit, TOAST_CONTAINER_ID } from 'ufinet-web-components'

const App = () => {
	return (
		<LayoutProvider>
			<Outlet />
			<MasterInit />
			<ToastContainer containerId={TOAST_CONTAINER_ID} />
		</LayoutProvider>
	)
}

export { App }
